<template>
  <div class="register">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      style="width: 100%; margin: 0 auto"
      :class="isShow"
    >
      <div>
        <h2 class="h2">中国人才交流协会人力资源服务业研究课题征集</h2>
      </div>
      <el-form-item
        prop="Name"
        :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
      >
        <el-input
          placeholder="姓名"
          v-model="ruleForm.Name"
          clearable
          maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="CompanyName"
        :rules="[
          { required: true, message: '请输入任职企业名称', trigger: 'blur' },
        ]"
      >
        <el-input
          placeholder="任职企业"
          v-model="ruleForm.CompanyName"
          clearable
          maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="Position"
        :rules="[{ required: true, message: '请输入职位', trigger: 'blur' }]"
      >
        <el-input
          placeholder="职位"
          v-model="ruleForm.Position"
          clearable
          maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="PhoneNumber"
        :rules="[
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号码' },
        ]"
      >
        <el-input
          placeholder="手机号码"
          v-model="ruleForm.PhoneNumber"
          clearable
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="Email"
        :rules="[
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input
          placeholder="邮箱"
          v-model="ruleForm.Email"
          clearable
          maxlength="100"
        ></el-input>
      </el-form-item>

      <el-form-item
        prop="Type"
        label="申报课题类别"
        :rules="[
          { required: true, message: '请选择申报课题类别', trigger: 'change' },
        ]"
      >
        <el-radio-group v-model="ruleForm.Type">
          <el-radio
            v-for="item in TopicTypeList"
            :key="item"
            :label="item"
          ></el-radio>
        </el-radio-group>

        <el-input
          placeholder="课题方向必须为人力资源服务行业的研究（50字以内）"
          v-model="TypeOther"
          maxlength="50"
          v-if="this.ruleForm.Type.indexOf('其他') >= 0"
          style="display: inline"
        ></el-input>
      </el-form-item>

      <el-form-item
        prop="Desc"
        label="课程研究内容概述："
        :rules="[
          {
            required: true,
            message: '请输入课程研究内容概述',
            trigger: 'blur',
          },
        ]"
      >
        <el-input
          placeholder="课题研究内容概述：提报方撰写选定课题开课概述，字数控制再300字以内。"
          type="textarea"
          :rows="5"
          v-model="ruleForm.Desc"
          clearable
          maxlength="350"
        ></el-input>
      </el-form-item>

      <el-form-item style="text-align: center">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="addLoading"
          >提 交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { AddOrUpdTopic } from '../api/api'
export default {
  data() {
    return {
      isShow: 'show',
      addLoading: false,
      addWinningInfo: true,
      TopicTypeList: [
        '人力资源服务业市场研究',
        '人力资源服务业数字化',
        '人力资源服务创新发展（产品、技术、模式等）',
        '人力资源服务业资本化运作',
        '灵活用工',
        '人力资源服务行业助力就业',
        '人力资源服务行业薪酬',
        '人力资源服务行业人效',
        '组织变革与人才发展',
        '办公形式趋势与变化',
        '其他（可自行填写填报）',
      ], // 申报课题类别
      ruleForm: {
        TopicName: '中国人才交流协会人力资源服务业研究课题征集',
        Name: '',
        CompanyName: '',
        Position: '',
        PhoneNumber: '',
        Email: '',
        Type: '',
        Desc: '',
      },
      TypeOther: '',
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 判断课题类别是否选择其他
          if (this.ruleForm.Type.indexOf('其他') >= 0) {
            // 判断是否输入课题类别
            if (
              this.TypeOther.trim() === '' ||
              this.TypeOther.trim() === null
            ) {
              this.$message({
                message: '请输入申报课题类别',
                type: 'warning',
              })
              return false
            }
          }

          const params = {
            TopicName: this.ruleForm.TopicName,
            Name: this.ruleForm.Name,
            CompanyName: this.ruleForm.CompanyName,
            Position: this.ruleForm.Position,
            PhoneNumber: this.ruleForm.PhoneNumber,
            Email: this.ruleForm.Email,
            Type:
              this.ruleForm.Type.indexOf('其他') >= 0
                ? this.TypeOther
                : this.ruleForm.Type,
            Desc: this.ruleForm.Desc,
          }
          AddOrUpdTopic(params).then((res) => {
            console.log(res)
            if (res.data.success) {
              this.$router.push('/success')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.el-radio-button__inner,
.el-radio-group {
  line-height: 30px;
}

.el-form-item__label {
  font-weight: bold;
}

.el-radio {
  width: 48% !important;
  margin-right: 0;
}

.set-label > .el-form-item__label {
  width: 30px !important;
}
.spanTitle {
  font-weight: bold;
}
.addWinningInfo {
  padding-left: 90px;
  margin-bottom: 30px;
}
.hide {
  display: none;
}
.show {
  display: block;
}
.register {
  width: 60%;
  margin: 0 auto;
  padding-bottom: 30px;
}
.h2 {
  margin: 30px auto;
  text-align: center;
}
.v-modal {
  position: absolute;
  left: 0;
  top: 0;
  background: none;
}
.divInfo {
  /* border: 1px solid #e1e1e1;
  padding: 5px; */
  position: relative;
}
.items {
  display: flex;
  flex-wrap: wrap;
  line-height: 24px;
  margin-bottom: 15px;
}
.items div + div {
  padding-right: 15px;
}
.items div.yx {
  padding-right: 0;
}
.items .jx {
  width: auto;
  padding-right: 15px;
}
.items .sf {
  width: auto;
}
.items .xm {
  width: auto;
}
.items .zw {
  width: auto;
}
.items .sj {
  width: auto;
}
.items .yx {
  width: auto;
}

@media (max-width: 800px) {
  .register {
    width: 94%;
  }
  .h2 {
    font-size: 18px;
  }

  .el-radio {
    width: 99% !important;
    margin-right: 0;
  }
}
</style>
